
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const CommunityGuidelines = () => {
    // const [loader, setLoader] = useState(false)
    // const [cmsDetails, setCmsDetails] = useState({});

    // useEffect(() => {
    //     setLoader(true)
    //     cmsDetailsAction({ slug: "rules" }, (response) => {
    //         if (response?.status === true) {
    //             setCmsDetails(response?.data)
    //         }
    //         setLoader(false)
    //     })();
    // }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    Rules
                    {/* {cmsDetails.title} */}
                    {/* {cmsDetails?.updatedAt ? moment(cmsDetails.updatedAt).format("YYYY-MM-DD") : "-"} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}
                    <div className="cms_content_text">
                        <div>
                            <h1><strong>Millionaire11 Community Guidelines</strong></h1>
                            <p><br /></p>
                            <p>At <strong>Millionaire11</strong>, we are committed to maintaining an <strong>open, respectful, and secure</strong> platform for all users. Our <strong>Community Guidelines</strong> are designed to promote a <strong>fair and responsible gaming environment</strong> where everyone can participate with confidence.</p>
                            <p><br /></p>
                            <p>By accessing and using our platform, you agree to adhere to these guidelines. Violations may lead to <strong>content removal, account suspension, or permanent bans</strong>. In severe cases, we may report violations to relevant authorities.</p>
                            <p><br /></p>
                            <h2><strong>Prohibited Conduct and Content</strong></h2>
                            <p><br /></p>
                            <h3><strong>1. Spam and Malicious Activities</strong></h3>
                            <p><br /></p>
                            <p>❌ Avoid posting repetitive, unsolicited, or misleading content.</p>
                            <p>❌ Do not use bots, scripts, or automated tools to manipulate interactions.</p>
                            <p>❌ Refrain from redirecting users to deceptive or malicious external sites.</p>
                            <p>❌ Never engage in unfair monetary transactions for undue advantage.</p>
                            <h3><br /></h3>
                            <h3><strong>2. Misinformation and Impersonation</strong></h3>
                            <p><br /></p>
                            <p>✅ Ensure all information on your account is accurate and up-to-date.</p>
                            <p>❌ Do not impersonate individuals, brands, or entities to mislead others.</p>
                            <p>❌ Avoid spreading false or deceptive content that could cause harm or confusion.</p>
                            <p>❌ Creating accounts to bypass restrictions or bans is strictly prohibited.</p>
                            <p><br /></p>
                            <h3><strong>3. Violence and Criminal Behavior</strong></h3>
                            <p><br /></p>
                            <p>❌ Any form of violence, hate speech, or criminal activity will not be tolerated.</p>
                            <p>❌ Do not glorify, promote, or encourage acts of fraud, exploitation, or harm.</p>
                            <p>❌ Threats or incitement of harm against individuals, groups, or animals are strictly forbidden.</p>
                            <h3><br /></h3>
                            <h3><strong>4. Harassment and Bullying</strong></h3>
                            <p><br /></p>
                            <p>✅ Respect all users and engage in a positive manner.</p>
                            <p>❌ Do not engage in targeted harassment, abuse, or personal attacks.</p>
                            <p>❌ Sharing personal information of others without explicit consent is prohibited.</p>
                            <p>❌ Content that mocks or ridicules individuals or groups is not allowed.</p>
                            <h3><br /></h3>
                            <h3><strong>5. Hate Speech</strong></h3>
                            <p><br /></p>
                            <p>❌ Do not post content that incites hatred or violence against any individual or group.</p>
                            <p>❌ Avoid discriminatory language based on race, religion, gender, disability, or identity.</p>
                            <h3><br /></h3>
                            <h3><strong>6. Copyright Infringement</strong></h3>
                            <p><br /></p>
                            <p>✅ Only post original content or content for which you have proper authorization.</p>
                            <p>❌ Do not plagiarize, steal, or misrepresent other users’ creations or intellectual property.</p>
                            <h3><br /></h3>
                            <h3><strong>7. Platform Security</strong></h3>
                            <p><br /></p>
                            <p>✅ Help maintain the security of our platform.</p>
                            <p>❌ Do not engage in hacking, phishing, or unauthorized access to accounts or data.</p>
                            <p>❌ Avoid sharing or promoting malware, viruses, or other harmful software.</p>
                            <p>❌ Never disclose sensitive user information, such as financial or personal identification details.</p>
                            <h3><br /></h3>
                            <h3><strong>8. Offensive and Inappropriate Content</strong></h3>
                            <p><br /></p>
                            <p>❌ Any content involving child exploitation, explicit sexual material, or suggestive depictions of minors is strictly prohibited.</p>
                            <p>❌ Do not post imagery, videos, or language that promotes violence, sexual assault, or exploitation.</p>
                            <p><br /></p>
                            <h2><strong>Restricted States for Paid Contests</strong></h2>
                            <p><br /></p>
                            <p>Participation in Paid Contests is prohibited in the following states due to applicable laws and regulations:</p>
                            <p><br /></p>
                            <p>❌ <strong>Andhra Pradesh</strong></p>
                            <p>❌ <strong>Assam</strong></p>
                            <p>❌ <strong>Nagaland</strong></p>
                            <p>❌ <strong>Sikkim</strong></p>
                            <p>❌ <strong>Telangana</strong></p>
                            <p><br /></p>
                            <p>By accessing Paid Contests, you confirm that you do not reside in any of these restricted states. You also agree not to provide false information, declarations, or representations to circumvent the applicable laws and regulations of these territories ("Applicable Law").</p>
                            <h2><br /></h2>
                            <h2><strong>Reporting and Moderation</strong></h2>
                            <h3><br /></h3>
                            <h3><strong>📌 Reporting Violations</strong></h3>
                            <p>We encourage users to report any violations through the "Report" feature on the platform. Please provide details such as:</p>
                            <ul>
                                <li>Username of the violator</li>
                                <li>Links to the violating content</li>
                                <li>A brief description of the issue</li>
                            </ul>
                            <h3><br /></h3>
                            <h3><strong>🛠 Moderation Actions</strong></h3>
                            <ul>
                                <li>Reported content will be reviewed promptly.</li>
                                <li>Necessary actions, including content removal or account suspension, will be taken.</li>
                                <li>Users with repeated violations may face permanent bans.</li>
                            </ul>
                            <h3><br /></h3>
                            <h3><strong>👥 Group Administration</strong></h3>
                            <p>Group administrators are responsible for ensuring a respectful and secure environment within their groups. They may:</p>
                            <p>✅ Remove users violating the guidelines.</p>
                            <p>✅ Limit group interactions when necessary.</p>
                            <h2><br /></h2>
                            <h2><strong>Enforcement and Updates</strong></h2>
                            <p><br /></p>
                            <p>These Community Guidelines are subject to periodic updates. Continued use of the platform constitutes acceptance of any revisions.</p>
                            <p>Significant updates will be communicated via email or in-app notifications.</p>
                            <p>By fostering a respectful, secure, and inclusive community, we aim to provide an exceptional experience for all users.</p>
                            <p><br /></p>
                            <p>Thank you for being a valued part of the Millionaire11 community! 🎉🏏</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CommunityGuidelines